import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import './MetroDistances.css';

const MetroDistancesComponent = ({ distances }) => {
  const sortedDistances = [...distances].sort((a, b) => {
    return parseFloat(a.drivingDistance, 10) - parseFloat(b.drivingDistance, 10);
  });

  return (
    <div>
      {sortedDistances.map((distance, index) => (
        <div className="metro-distances" key={index}>
          <p>
            <ViewerPrimaryColorUserStyle domStyle="color">
              <b>{index + 1}&nbsp;</b>
            </ViewerPrimaryColorUserStyle>
            <b>{distance.city}</b>
          </p>
          <p>Driving Distance: {distance.drivingDistance} miles</p>
          {distance.daysByRail && <p>Days By Rail: {distance.daysByRail}</p>}
          {distance.daysByTruck && <p>Days By Truck: {distance.daysByTruck}</p>}
          {distance.flightTime && <p>Flight Time: {distance.flightTime}</p>}
        </div>
      ))}
    </div>
  );
};

MetroDistancesComponent.propTypes = {
  distances: PropTypes.arrayOf(PropTypes.shape({
    city: PropTypes.string,
    daysByRail: PropTypes.string,
    daysByTruck: PropTypes.string,
    drivingDistance: PropTypes.string,
    flightTime: PropTypes.string,
  })),
};

export default MetroDistancesComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/MetroDistances.js